import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import Roomavailability from '../Pages/Roomavailability'
import Carousel from '../Pages/Carousel'
import Homeaboutus from '../Pages/Homeaboutus'
import Testimonials from '../Pages/Testimonials'
import HomeRooms from '../Pages/HomeRooms'
import HomeService from '../Pages/HomeService'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'

const Home = () => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);


    return (
        <>
            <Header />
            <Carousel />
            <Roomavailability />
            <Homeaboutus />
            <HomeRooms />
            <div>
                {loading ? (
                    <>
                        <div className="container-xxl py-5 px-0 wow zoomIn" data-wow-delay="0.1s">
                            <div className="row g-0">
                                <div className="col-md-6 bg-dark d-flex align-items-center">
                                    <div className="p-5">
                                        <h6 className="section-title text-start text-white text-uppercase mb-3"><Skeleton width={130} height={20} /></h6>
                                        <h1 className="text-white mb-4"><Skeleton width={"100%"} height={30} /></h1>
                                        <p className="text-white mb-4"><Skeleton width={"100%"} height={80} /></p>
                                        <Link to="/rooms" className="btn py-md-3 px-md-5 me-3"><Skeleton width={130} height={50} /></Link>
                                        <Link className="btn py-md-3 px-md-5 mt-md-0 mt-3">
                                            <Skeleton width={130} height={50} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="video">
                                        <Skeleton width={"100%"} height={300} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="videoModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content rounded-0">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">Youtube Video</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                        {/* 16:9 aspect ratio */}
                                        <div className="ratio ratio-16x9">
                                            <iframe className="embed-responsive-item" src id="video" allowFullScreen allowscriptaccess="always" allow="autoplay" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="container-xxl py-5 px-0 wow zoomIn" data-wow-delay="0.1s">
                            <div className="row g-0">
                                <div className="col-md-6 bg-dark d-flex align-items-center">
                                    <div className="p-5">
                                        <h6 className="section-title text-start text-white text-uppercase mb-3">Luxury Living</h6>
                                        <h1 className="text-white mb-4">Discover A Brand Luxurious Hotel</h1>
                                        <p className="text-white mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                                        <Link to="/rooms" className="btn btn-primary py-md-3 px-md-5 me-3">Our Rooms</Link>
                                        <Link onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                                        }} className="btn btn-light py-md-3 px-md-5 mt-md-0">
                                            Book A Room
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="video" style={{ backgroundImage: "url('/img/video.jpg')" }}>
                                        <button type="button" className="btn-play" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-bs-target="#videoModal">
                                            <span />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="videoModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content rounded-0">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">Youtube Video</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                        {/* 16:9 aspect ratio */}
                                        <div className="ratio ratio-16x9">
                                            <iframe className="embed-responsive-item" src id="video" allowFullScreen allowscriptaccess="always" allow="autoplay" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>

            <HomeService />
            <Testimonials />
            <Footer />
        </>
    )
}

export default Home
